// Chart layout constants + pure layout helpers shared by InteractiveGraph.
//
// MOVED here verbatim from InteractiveGraph.js (module-level pure constants and
// functions; the only change is the `export ` keyword added to each moved
// top-level declaration) as maintenance-only Slice 1 of the InteractiveGraph
// split — same "verbatim move + single source" pattern as
// overlayStageVisibility.js (v2.14.19). InteractiveGraph imports these back,
// so every call site is unchanged. Behavior must stay byte-identical: do NOT
// add component-/state-aware logic here.
//
// NOTE: COMPACT_CHART_HEIGHT intentionally stays in InteractiveGraph.js
// (currently unreferenced there; moving it would change the ESLint baseline).

export const MIN_CHART_WIDTH = 400;
export const MAX_CHART_WIDTH = 1400;
export const MIN_CHART_HEIGHT = 360;
export const MAX_CHART_HEIGHT = 900;
export const MIN_MARGIN = 20;
export const MIN_LEGEND_WIDTH = 160;
export const LEGEND_SNAP_THRESHOLD = 24;
export const LEGEND_KEYBOARD_STEP = 12;
export const LEGEND_KEYBOARD_FAST_STEP = 32;

export const clampValue = (value, min, max) => Math.min(Math.max(value, min), max);
export const clamp01 = (value) => Math.min(Math.max(value, 0), 1);

export const DEFAULT_LAYOUT = {
  width: 900,
  height: 550,
  margin: { top: 80, right: 160, bottom: 110, left: 80 },
  legend: { position: 'right', width: 140, top: 60, bottomSpacing: 120, mode: 'auto', x: null, y: null, height: null },
  axis: {
    xTickFontSize: 20,
    xTickRotation: 0,
    xTickOffsetX: 0,
    xTickOffsetY: 10,
    yTickFontSize: 20,
    xLabelFontSize: 20,
    yLabelFontSize: 20
  }
};

// 軸・凡例・値ラベルの文字サイズは「グローバル設定」として保存する固定キー。
// グラフ/ステージ単位の色設定キー（colorPreferenceStorageKey）とは独立で、
// 一度調整すれば全グラフ・全ステージ・全セッションでその大きさを維持する。
export const GLOBAL_TEXT_SIZE_STORAGE_KEY = 'graphTutor::textSizePrefs::v1';

export const cloneLayout = (layout) => ({
  width: layout.width,
  height: layout.height,
  margin: { ...layout.margin },
  legend: { ...layout.legend },
  axis: { ...layout.axis }
});
